import script from "./AuditedPartyIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./AuditedPartyIndex.vue?vue&type=script&setup=true&lang=js"

import "./AuditedPartyIndex.vue?vue&type=style&index=0&id=5a182996&lang=css"
import "./AuditedPartyIndex.vue?vue&type=style&index=1&id=5a182996&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a182996"]])

export default __exports__